// extracted by mini-css-extract-plugin
module.exports = {"TitleAndText":"TitleAndText_TitleAndText__yOwDp","title":"TitleAndText_title__1Us4A","text":"TitleAndText_text__1u_ec","row":"TitleAndText_row__3v4VO"};